import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    IconButton,
    Tooltip,
    Chip
} from '@mui/material';
import { Restore } from '@mui/icons-material';
import { PackageHistoryDto } from '../../../api/models/PackageDto';

interface HistoryTableProps {
    history: PackageHistoryDto[];
    selectedVersions: string[];
    onVersionSelect: (validFrom: string, checked: boolean) => void;
    onRestore: (version: PackageHistoryDto) => void;
}

const HistoryTable: React.FC<HistoryTableProps> = ({
    history,
    selectedVersions,
    onVersionSelect,
    onRestore
}) => {
    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleString();
    };

    return (
        <TableContainer
            component={Paper}
            sx={{ width: "92%", pb: 0, mb: "70px", mt: "10px" }}
        >
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: "3%" }}>
                            <b>Select</b>
                        </TableCell>
                        <TableCell sx={{ width: "15%" }}>
                            <b>Name</b>
                        </TableCell>
                        <TableCell sx={{ width: "20%" }}>
                            <b>Description</b>
                        </TableCell>
                        <TableCell sx={{ width: "8%" }}>
                            <b>Published</b>
                        </TableCell>
                        <TableCell sx={{ width: "15%" }}>
                            <b>Changed By</b>
                        </TableCell>
                        <TableCell sx={{ width: "12%" }}>
                            <b>Valid From</b>
                        </TableCell>
                        <TableCell sx={{ width: "12%" }}>
                            <b>Valid To</b>
                        </TableCell>
                        <TableCell sx={{ width: "5%" }}>
                            <b>Actions</b>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {history.map((version: PackageHistoryDto) => (
                        <TableRow key={version.validFrom}>
                            <TableCell>
                                <Checkbox
                                    checked={selectedVersions.includes(version.validFrom)}
                                    onChange={(e) => onVersionSelect(version.validFrom, e.target.checked)}
                                    disabled={selectedVersions.length >= 2 && !selectedVersions.includes(version.validFrom)}
                                />
                            </TableCell>
                            <TableCell>{version.name}</TableCell>
                            <TableCell>{version.description}</TableCell>
                            <TableCell>
                                <Chip 
                                    label={version.published ? "Published" : "Draft"} 
                                    color={version.published ? "success" : "default"}
                                    size="small"
                                />
                            </TableCell>
                            <TableCell>
                                {version.modifiedByName ? (
                                    <Tooltip title={version.modifiedByEmail || ''}>
                                        <span>{version.modifiedByName}</span>
                                    </Tooltip>
                                ) : '-'}
                            </TableCell>
                            <TableCell>{formatDate(version.validFrom)}</TableCell>
                            <TableCell>{formatDate(version.validTo)}</TableCell>
                            <TableCell>
                                <Tooltip title="Restore Version">
                                    <IconButton 
                                        onClick={() => onRestore(version)}
                                        size="small"
                                        color="warning"
                                    >
                                        <Restore />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default HistoryTable;